import { combineReducers } from 'redux';
import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';

// defaults to local storage
import storage from 'redux-persist/lib/storage';
import { persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER, } from 'redux-persist';

// reducers
import userReducer from './reducers/user';
import distributionReducer from './reducers/distribution';
import imageReducer from './reducers/image';
import toastReducer from './reducers/toast';
import customerReducer from './reducers/customers';
import customerRecommendationReducer from './reducers/customers/customer-recommendation';
import countriesReducer from './reducers/countries/countriesReducer';

const rootReducer = combineReducers({
    user: userReducer,
    distribution: distributionReducer,
    image: imageReducer,
    toast: toastReducer,
    customer: customerReducer,
    countries: countriesReducer,
    customerRecommendation: customerRecommendationReducer
});

const persistedReducer =
    persistReducer({ key: 'root', storage }, rootReducer);

const store = configureStore({
    reducer: persistedReducer,
    middleware: getDefaultMiddleware({
        serializableCheck: {
            ignoredActions: [
                FLUSH, REHYDRATE,
                PAUSE, PERSIST, PURGE, REGISTER],
        },
    }),
});

export default store;
